import { createSelector } from 'reselect';

import {
  // Utils
  localizedLink,
  // Frame
  hasUserSelector,
  localeSelector,
  peopleDirectoryFooterSelector,
  jobsFooterSelector,
  eventsFooterSelector,
  newsFooterSelector,
  groupsFooterSelector,
  companiesFooterSelector,
  coachesFooterSelector,
} from '@xingternal/platform-layout-selectors';

const mainSectionsSelector = createSelector(
  hasUserSelector,
  localeSelector,
  peopleDirectoryFooterSelector,
  jobsFooterSelector,
  eventsFooterSelector,
  newsFooterSelector,
  groupsFooterSelector,
  companiesFooterSelector,
  coachesFooterSelector,
  (
    hasUser,
    locale,
    peopleDirectoryFooter,
    jobsFooter,
    eventsFooter,
    newsFooter,
    groupsFooter,
    companiesFooter,
    coachesFooter
  ) => {
    return !hasUser
      ? [
          peopleDirectoryFooter,
          jobsFooter,
          eventsFooter,
          newsFooter,
          groupsFooter,
          companiesFooter,
          coachesFooter,
        ]
          .filter(Boolean)
          .map(localizedLink(locale))
      : [];
  }
);

export { mainSectionsSelector };
